import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../../components/layout';
import SEO from '../../components/seo';
import ItemPreview from '../../components/itemPreview';

export default ({ data, params }) => {
  const items = data.allDataJson.nodes;

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const type = params.type.split(' ').map(capitalize).join(' ');

  return (
    <Layout>
      <SEO
        title={`${type} Type`}
        description={`A collection of Growtopia's game item with the type of ${type}.`}
      />
      <h2 id="type">
        A collection of Growtopia's game items with the type of{' '}
        <strong>{type}</strong>.
      </h2>
      <br />
      <ul>
        {items.map((item, i) => (
          <li key={item.name}>
            <ItemPreview data={item} />
          </li>
        ))}
      </ul>
    </Layout>
  );
};

export const query = graphql`
  query($type: String!) {
    allDataJson(filter: { type: { eq: $type } }) {
      nodes {
        name
        rarity
      }
    }
  }
`;
